export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 text-center">
            关于桃子影院
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              <strong className="text-foreground-950">桃子影院</strong>是一个专注于提供<strong className="text-foreground-950">高清影视在线观看</strong>服务的综合平台。
              我们致力于为广大影视爱好者打造一个内容丰富、体验流畅、完全免费的观影空间。
              平台涵盖国产剧、韩剧、美剧、日剧、动漫、综艺、纪录片等多元品类，累计收录超过万部高清影视资源。
            </p>
            <p>
              依托先进的分布式CDN加速网络和智能视频编码技术，桃子影院实现了超清蓝光4K画质的秒开播放，
              让每一位用户都能享受到不缓冲、不卡顿的极致观影体验。我们坚持<strong className="text-foreground-950">永久免费</strong>的运营理念，
              不设置任何付费墙或会员门槛，让优质影视内容真正普惠大众。
            </p>
            <p>
              平台每日保持<strong className="text-foreground-950">50部以上</strong>的剧集更新速度，涵盖国内外热门剧集的最新播出内容。
              我们的内容团队全天候监控各大播出平台，确保剧集上线后第一时间同步至桃子影院，
              让追剧不再等待，精彩即刻呈现。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}